export const WAEC_MARKETING = [];
